import React from 'react';
import { useSelector } from 'react-redux';

import { MirrorService } from 'services/MirrorService';

import { usePartnerId } from 'hooks/usePartnerId';
import {
  getHasNotifications,
  getNewDialogsCount,
} from 'store/common/selectors';

import { LocalsDateBottomNavigationBar } from './LocalsDateBottomNavigationBar';
import { MeplusyouBottomNavigationBar } from './MeplusyouBottomNavigationBar';
import { SimpleDatesBottomNavigationBar } from './SimpleDatesBottomNavigationBar';

export const BottomNavigationBar = () => {
  const newDialogsCount = useSelector(getNewDialogsCount);
  const hasNotifications = useSelector(getHasNotifications);

  const { isOrganicPartnerIdOnMainMirror } = usePartnerId();

  if (MirrorService.isMePlusYouOrLocalsjoy) {
    return (
      <MeplusyouBottomNavigationBar
        isHasNewDialogs={Boolean(newDialogsCount)}
        isHasNewNotifications={hasNotifications}
      />
    );
  }

  if (MirrorService.isLocalsDateOrLustStation) {
    return (
      <LocalsDateBottomNavigationBar
        isHasNewDialogs={Boolean(newDialogsCount)}
        isHasNewNotifications={hasNotifications}
        isVideoIconHide={isOrganicPartnerIdOnMainMirror}
      />
    );
  }

  if (MirrorService.isSimpleDates) {
    return <SimpleDatesBottomNavigationBar newDialogsCount={newDialogsCount} />;
  }

  return null;
};
